import S from 'constants/string.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

export const fromUserNameToFirstName = (userName) => fromAnyToTrimmed(userName).split(/\s+/)[0] || S.empty;
